import React, { useState } from "react";
import { useParams } from "react-router-dom";

import { useAppDispatch } from "../../../app/hooks";

import { Input } from "../../../components/ui/input/SimpleInput";

import { updateCase } from "../../../thunks/Case";
import { useAppSelector } from "../../../app/store";
import { getEmployeeIds } from "../../caseinfo/logic/Slice";
import { AddEntitiesModal } from "./AddEntitiesModal";
import { showErrorToast } from "../../../lib/toast";

interface AddEmployeeModalProps {
  onClose: () => void;
  onBack?: () => void;
}

const AddEmployeeModal: React.FC<AddEmployeeModalProps> = ({
  onClose, onBack
}) => {
  const dispatch = useAppDispatch();
  const { id: caseId } = useParams<{ id: string }>();
  const employeeIds = useAppSelector(getEmployeeIds);

  const [employeeId, setEmployeeId] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  const handleDiscard = () => {
    setEmployeeId("");
    onClose();
  };

const handleSave = async () => {
  if (!caseId || !employeeId.trim()) {
    return;
  }

  setIsSaving(true);

  const updatedEmployees = [
    ...employeeIds,
    employeeId.trim(),
  ];

  try {
    await dispatch(
      updateCase({
        caseId,
        request: {
          employee_ids: updatedEmployees,
        },
      })
    ).unwrap();

    onClose();

    } catch (error) {
      showErrorToast("Failed to save changes. Please try again.");
    } finally {
      setIsSaving(false);
  }
};

  return (
    <AddEntitiesModal
      title="Add Employee Details"
      onClose={onClose}
      onBack={onBack}
      onDiscard={handleDiscard}
      onSave={handleSave}
      saveEnabled={!!employeeId && !isSaving}
      isSaving={isSaving}
    >
      <div>
        <label className="block text-sm font-medium text-[#0A0A0A] mb-1">
          Employee ID
        </label>

        <Input
          type="text"
          placeholder="Enter employee ID"
          value={employeeId}
          onChange={e => setEmployeeId(e.target.value)}
          disabled={isSaving}
          className="
            h-9
            px-3
            border-[#E5E5E5]
            shadow-[0_1px_2px_rgba(0,0,0,0.05)]
          "
        />
      </div>
    </AddEntitiesModal>
  );
};

export default AddEmployeeModal;